import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '@standardnotes/snjs';
const CountBubble = ({ count, position, className }) => {
    if (!count) {
        return null;
    }
    return (_jsx("div", { className: classNames('flex aspect-square h-5 w-5 items-center justify-center rounded-full border border-info-contrast bg-info text-[0.75rem] font-bold text-info-contrast md:text-[0.65rem]', 'absolute bottom-full translate-y-3 md:translate-y-2', position === 'left' ? 'right-full md:translate-x-2' : 'left-full -translate-x-3 md:-translate-x-2.5', className), children: count }));
};
export default CountBubble;
